import "./index.css";
import { Wrapper } from "../../layout";
import InputValidationWarning from "../InputValidationWarning";
import AmerLabel from "../AmerLabel";

export default function ControlledTextInput({ 
    id,
    label, 
    name,
    handleChange, 
    value = "", 
    placeholder,
    bold = true,
    required = false,
    warning = "",
    disabled = false,
    readonly = false,
    maxLength,
    defaultWidth,
    expand = true
}) {

    return (
        <Wrapper grow={expand} base={defaultWidth}>
            <AmerLabel value={label} inputId={id} bold={bold} required={required}/>
            <input
                // temporary solution for focus state while we don't have tailwind
                id={id}
                className="controlled-text-input"
                value={value}
                name={name}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
                readOnly={readonly}
                maxLength={maxLength}
                style={{
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    appearance: "none",
                    borderRadius: "5px",
                    backgroundColor: "#fff",
                    padding: ".375rem .75rem",
                    margin: 0,
                    height: "58px",
                    fontSize: "1rem",
                    fontWeight: 400,
                    fontFamily: "inherit",
                    color: "#212529",
                    lineHeight: 1.5,
                }}
            ></input>
            <InputValidationWarning warning={warning}/>
        </Wrapper>
    )
}